export default "__VITE_ASSET__D0Qb9ROO__"